import { useEffect } from "react";
import { useTourStoreApi } from "@heroncendre/player";
import { dansUnChamp } from "./RaccourciEdition.js";

/**
 * ============================================================================
 *  FlechesRotation.tsx — Tourner la vue au clavier
 * ----------------------------------------------------------------------------
 *  Le moteur ne tourne la vue qu'à la souris et au doigt. L'indicateur de
 *  rotation promet pourtant, sur ordinateur, « les flèches ← → du clavier » :
 *  cette promesse est tenue ici, et seulement en visite libre.
 *
 *  En parcours narratif, ← et → appartiennent à la voix off (reculer, avancer
 *  de dix secondes, voir `NarrationControls` du moteur) : les deux usages se
 *  battraient pour la même touche. L'indicateur n'y mentionne donc pas le
 *  clavier.
 *
 *  Le cap s'écrit dans le store (`setView`), comme le fait un geste : la
 *  caméra s'y aligne à l'image suivante, et la rotation au repos du moteur
 *  repart de zéro puisque le cap a changé sous elle.
 * ==========================================================================*/

/** Un appui : ~8°, l'équivalent des 60 px du prototype. */
export const PAS_CLAVIER_DEG = 8;

/** Arme ← et →. Ne rend rien. */
export function FlechesRotation({ actif }: { actif: boolean }) {
  const store = useTourStoreApi();

  useEffect(() => {
    if (!actif) return;

    const surTouche = (event: KeyboardEvent) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      if (event.defaultPrevented || dansUnChamp(event.target)) return;
      event.preventDefault();
      const { view, setView } = store.getState();
      // Le cap croît vers la droite : ← regarde à gauche.
      setView({ yaw: view.yaw + (event.key === "ArrowLeft" ? -PAS_CLAVIER_DEG : PAS_CLAVIER_DEG) });
    };

    window.addEventListener("keydown", surTouche);
    return () => window.removeEventListener("keydown", surTouche);
  }, [actif, store]);

  return null;
}
